import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		// USD /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-military-calisthenics&exp=web_mil_calisthenics_m_tai_chi_prices~1
		// EUR /result_complete?safe&mock-data&utm_source=FB&country=DE&area=activity-male-military-calisthenics&exp=web_mil_calisthenics_m_tai_chi_prices~1
		'activity-male-military-calisthenics': {
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_mil_calisthenics_m_tai_chi_prices'),
			},
		},
	},
]

export default config
